module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Let\u0027s talk!","intro":"Tell us a bit about your plans, we will get back to you within a couple of days."},"nl":{"title":"Let\u0027s talk!","intro":"Vertel ons een beetje over je plannen, dan krijg je binnen 2 dagen een berichtje van ons."}}')
  delete Component.options._Ctor
}
